module.exports = __webpack_public_path__ + "static/media/contact man.7689b763.png";